const CHANGE_TIPP_TIME_MS = 17000;

export const PIANO2NOTES_SINGLE_PRODUCT = 650761;

const AUTH_URL = 'https://auth.klang.io/';
const DOMAIN_BASE_URL = 'https://ai2notes.klang.io/api/auth';

const COMPANY_URL = 'https://klang.io';

// estimated transcription duration
const FULL_ESTIMATED_DURATION_SEC = 60;
const DEMO_ESTIMATED_DURATION_SEC = 20;
const FULL_YT_ESTIMATED_DURATION_SEC = 3 * 60;
const DEMO_YT_ESTIMATED_DURATION_SEC = 60;

export {
  CHANGE_TIPP_TIME_MS,
  COMPANY_URL,
  FULL_ESTIMATED_DURATION_SEC,
  DEMO_ESTIMATED_DURATION_SEC,
  FULL_YT_ESTIMATED_DURATION_SEC,
  DEMO_YT_ESTIMATED_DURATION_SEC,
  AUTH_URL,
  DOMAIN_BASE_URL,
};
